import { render, staticRenderFns } from "./ProductionCost.vue?vue&type=template&id=7940484c&scoped=true"
import script from "./ProductionCost.vue?vue&type=script&lang=js"
export * from "./ProductionCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7940484c",
  null
  
)

export default component.exports